/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultPricingAnalyticsParams } from '../../models/api-response-paged-result-pricing-analytics-params';
import { PricingAnalyticsRequest } from '../../models/pricing-analytics-request';

export interface GetPricingAnalytics$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  request: PricingAnalyticsRequest;
  page?: number;
  size?: number;
}

export function getPricingAnalytics(http: HttpClient, rootUrl: string, params: GetPricingAnalytics$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultPricingAnalyticsParams>> {
  const rb = new RequestBuilder(rootUrl, getPricingAnalytics.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('request', params.request, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultPricingAnalyticsParams>;
    })
  );
}

getPricingAnalytics.PATH = '/v1/api/ui/meta-pricing-analytics';
